import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reception-view',
  templateUrl: './reception-view.component.html',
  styleUrls: ['./reception-view.component.scss']
})
export class ReceptionViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
